<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-select
        :items="items"
        return-object
        v-model="item"
        label="Typ osoby"
        :hide-details="hideDetails"
        :outline="outline"
        class="mx-2"
        :rules="rules"
        :disabled="disabled"
        item-text="value"
      ></v-select>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  data: function () {
    return {
      items: [
        { name: 'po', value: 'Právnická osoba' },
        { name: 'fo', value: 'Fyzická osoba' },
        { name: 'osvc', value: 'OSVČ' }
      ],
      item: null
    }
  },
  props: {
    hideDetails: Boolean,
    outline: Boolean,
    rules: Array,
    value: String,
    all: Boolean,
    disabled: Boolean
  },
  watch: {
    item (v) {
      this.$emit("changed", v);
      this.$emit("input", v.name);
    }
  },
  mounted: function() {
    if (typeof this.value != "undefined") {
      var v = this.value;
      var f = this.items.filterOne((e) => { return e.name == v; });
      if (f != null)
        this.item = f;
    }
  },
  methods: {

  },
  components: {

  }
}
</script>
<style scoped>
.v-select__selection-text {
  max-width: 100px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/TypOsoby.vue